/**
 * The hub user behind a "Login as Customer" session, sent as ?tracking_id= on every API call.
 * Its own key so the `$fetch` interceptor can read it before Pinia hydrates. A claim anyone can
 * set in localStorage, not proof: attribution only, never authentication.
 */
export const TRACKING_ID_KEY = "tracking_id";

const USER_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Only a hub user id: a crafted ?loginAs= can't turn staff mode on with anything else.
export function isTrackingId(value: unknown): value is string {
  return typeof value === "string" && USER_ID.test(value);
}

// Same origin, not a string prefix: `startsWith` also matched `api.example.com.evil.com` and `api.example.com@evil.com`.
export function isApiUrl(url: string, apiBase: string): boolean {
  try {
    return new URL(url, globalThis.location?.href).origin === new URL(apiBase).origin;
  } catch {
    return false;
  }
}

// Storage errors (private mode, blocked storage) are swallowed: losing attribution never
// justifies breaking a session.
export function readTrackingId(): string | null {
  if (!import.meta.client) return null;
  try {
    return localStorage.getItem(TRACKING_ID_KEY);
  } catch {
    return null;
  }
}

export function writeTrackingId(id: string): void {
  if (!import.meta.client) return;
  try {
    localStorage.setItem(TRACKING_ID_KEY, id);
  } catch {
    /* blocked storage */
  }
}

export function clearTrackingId(): void {
  if (!import.meta.client) return;
  try {
    localStorage.removeItem(TRACKING_ID_KEY);
  } catch {
    /* blocked storage */
  }
}
